import React from 'react';
import ClassNames from 'classnames';
import Template from './validation-message.rt';
import Styles from './../validation.less';

module.exports = React.createClass({
  propTypes: {
    className: React.PropTypes.string,
    value: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.arrayOf(React.PropTypes.string)
    ])
  },
  getValue(){
    return (typeof this.props.value == 'array') ? (this.props.value[0] || '') : this.props.value;
  },
  getClass(){
    return ClassNames(Styles.message, this.props.className)
  },
  render: Template
});



/** WEBPACK FOOTER **
 ** ./src/validations/validation-message/index.js
 **/